import { Button, StatePanel } from "@moneymap/ui";
import type { ReactNode } from "react";

export function QueryState({
  isPending,
  isError,
  error,
  onRetry,
  loadingTitle = "Loading your current plan",
  children,
}: {
  isPending: boolean;
  isError: boolean;
  error: Error | null;
  onRetry: () => void;
  loadingTitle?: string;
  children: ReactNode;
}) {
  if (isPending) {
    return (
      <StatePanel title={loadingTitle} kind="loading">
        IterNest Money is reading the latest saved household state.
      </StatePanel>
    );
  }
  if (isError) {
    return (
      <StatePanel
        title="Your last saved plan is still safe"
        kind="error"
        action={
          <Button variant="secondary" type="button" onClick={onRetry}>
            Try again
          </Button>
        }
      >
        {error?.message ?? "This view could not be refreshed."}
      </StatePanel>
    );
  }
  return <>{children}</>;
}
